import { Navigate, Link } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
//
import Login from "./pages/Login";
import Register from "./pages/Register";
import DashboardApp from "./pages/DashboardApp";
import Products from "./pages/Products";
import Blog from "./pages/Blog";
import Members from "./pages/Members";
import NotFound from "./pages/Page404";
import Callender from "./pages/Callender";
import SportTypes from "./pages/SportTypes";
import Trainers from "./pages/Trainers";
import Payment from "./pages/Payement";
import Settings from "./pages/Settings";
import Profil from "./pages/Profil";
import RegiterReception from "./pages/RegisterReception";
import MemberAttendance from "./pages/MemberAttendance";
import Attendance from "./pages/Attendance";
import Subscriptions from "./pages/Subscription";
import ContactUs from "./pages/ContactUs";
import Branch from "./pages/Branch";

import SubscriptionCard from "./pages/SubscriptionCard";





// ----------------------------------------------------------------------

export default function Router(isAuth, isAdmin) {

  return [
    {
      path: "/dashboard",
      element: isAuth !== null ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { path: "app", element: <DashboardApp /> },
        { path: "members", element: <Members /> },
        
        { path: 'branches', element: <Branch /> },
        { path: "products", element: <Products /> },
        { path: "blog", element: <Blog /> },
        { path: "callender", element: <Callender /> },
        { path: "sportType", element: <SportTypes /> },
        { path: "trainers", element: <Trainers /> },
        { path: "payment", element: <Payment /> },
        { path: "profil", element: <Profil /> },
        { path: "settings", element: <Settings /> },
        { path: "attendance", element: <Attendance /> },
        { path: "member/attendance", element: <MemberAttendance /> },
        { path: "subscriptions", element: <Subscriptions /> },
        { path: "enquiry", element: <ContactUs /> }
      ],
    },
    {
      path: "/",
      element:
        isAuth === null ? <LogoOnlyLayout /> : <Navigate to="/dashboard/app" />,
      children: [
        { path: "/", element: <Navigate to="/login" /> },
        { path: "login", element: <Login /> },
        { path: "register", element: <Register /> },
        {path: "cards", element: <SubscriptionCard />},
        { path: "calendar", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ];
}